import React from 'react';
import { Col, Row } from 'antd';
import useIsUiHidden from '../../../hooks/dom/useIsUiHidden';
import RatingCard from '../CompanyRatings/RatingCard';

const Ratings = ({ defaultScore, bankruptcyScore }) => {
  const isUiHidden = useIsUiHidden();

  return (
    <Row
      gutter={isUiHidden ? [3] : [16, 16]}
      className="ant-row-pdf-gap no-break"
      style={{ pageBreakInside: 'avoid', pageBreakAfter: 'auto' }}
    >
      <Col className="flex" sm={24} md={12} lg={12} xl={12} xxl={12}>
        <RatingCard type="defaultRating" rating={defaultScore}></RatingCard>
      </Col>
      <Col className="flex" sm={24} md={12} lg={12} xl={12} xxl={12}>
        <RatingCard type="bankruptcyRating" rating={bankruptcyScore}></RatingCard>
      </Col>
    </Row>
  );
};
export default Ratings;
